var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertise"},[_c('v-row',_vm._l((_vm.advertises),function(item,index){return _c('v-col',{key:index,attrs:{"cols":"12","md":"6"}},[_c('a',{attrs:{"href":item.url}},[_c('v-img',{attrs:{"src":item.imgUrl}})],1)])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }